import { createSlice } from "@reduxjs/toolkit";
import { Alert, currentData, LayoutElement, loadInPageMultimgEditor, Placeholder, ReqParamsProps, TextsData, TransformedData } from "../../@types/data";
import {
  addCurrentDataLayoutData,
  addLayoutData,
  toggleAlert,
  toggleQrCode,
  updateActualMaxSizes,
  updateBorderRadiusState,
  updateCurrentData,
  updateCurrentDataFabricArray,
  updateExistingData,
  updateExistingDataCreating,
  updateIsExportable,
  updateParamGeneral,
  // updateFetchedData,
  // updateTooBigFontSizes
} from "../actions/dataActions";
import {
  decodeFromBase64, removeBase64Signature, removeSignatureFromLayout,
  setBase64Signature,
  updateImageData
} from "../actions/imageActions";
import {
  isTextTooBig,
  updateIsLoading,
  updateLayouts,
  updateScaleLayout,
  updateSelectedBackground,
  updateSelectedLayout
} from "../actions/layoutActions";
import {
  togglePlaceholder,
  updateFixFontSize,
  updateHAlign,
  updateText,
  updateTextColor,
  updateTextFontFamily,
  updateTextGeneratorReqParams,
  updateTextsData,
  updateTextSize,
  updateTooBigFontSizes,
  updateVAlign
} from "../actions/textActions";


export interface editorInterface {
  alert: Alert[];
  signatures: {
      layout: number[]; base64: string | null, color: string | null, position: { x: number, y: number } | null, size: {width: number; height: number } | null, angle: number
}[];
  isError: boolean;
  isLoading: boolean;
  qrCode: boolean;
  scale: number;
  layouts: LayoutElement[];
  selectedLayout: number;
  toolbarDisplay: {value: string, index?: number};
  currentData: currentData;
  existingData?: TransformedData | null;
  loadInPageMultimgEditor: loadInPageMultimgEditor;
  selectedBackground: {
    index: number,
    v: {
      type: string,
      value: string,
    };
    h: {
      type: string,
      value: string,
    };
    s: {
      type: string,
      value: string,
    };
  };
  exportBase64: string | null;
  limitFontSize: number;
  placeholder: Placeholder[];
  textGeneratorReqParams: ReqParamsProps[];
  maxSizes: {width: number, height: number, fontSize?: number};
  isExportable: boolean;
  textDatas: TextsData[];
}

const initialState: editorInterface = {
  alert: [],
  signatures: [],
  isError: false,
  isLoading: false,
  qrCode: false,
  scale: 1,
  layouts: [],
  selectedLayout: 0,
  toolbarDisplay: {value: "layout"},
  currentData: {
    paramGeneral: {
      layoutId: "",
      uid: "",
      prevPage: "",
      isRounded: false,
      isQRCode: false,
      isTextGenerator: false,
      isSignature: false,
      carteId: "",
      orient: "",
      page: null
    },
    layoutData: []
  },
  existingData: null,
  loadInPageMultimgEditor: {
    orient: "",
    preloadCard: "",
    carteId: "",
    photoId: "",
  },
  selectedBackground: {
    index: 0,
    v: {
      type: "color",
      value: "#fffffc"
    },
    h: {
      type: "color",
      value: "#fffffe",
    },
    s: {
      type: "color",
      value: "#fffffd",
    }
  },
  exportBase64: null,
  limitFontSize: 60,
  placeholder: [],
  textGeneratorReqParams: [],
  maxSizes: {width: 0, height: 0},
  isExportable: false,
  textDatas: [],
};

const editorSlice = createSlice({
  name: "editor",
  initialState,
  reducers: {
    setBase64Signature,
    decodeFromBase64,
    updateTextFontFamily,
    updateVAlign,
    updateHAlign,
    updateTextColor,
    updateText,
    updateTextSize,
    updateFixFontSize,
    updateLayouts,
    updateSelectedLayout,
    updateSelectedBackground,
    updateScaleLayout,
    // updateFetchedData,
    updateCurrentData,
    updateParamGeneral,
    updateImageData,
    updateTooBigFontSizes,
    updateBorderRadiusState,
    toggleAlert,
    toggleQrCode,
    isTextTooBig,
    addLayoutData,
    addCurrentDataLayoutData,
    updateCurrentDataFabricArray,
    togglePlaceholder,
    updateTextGeneratorReqParams,
    removeSignatureFromLayout,
    removeBase64Signature,
    updateActualMaxSizes,
    updateIsExportable,
    updateExistingData,
    updateExistingDataCreating,
    updateTextsData,
    updateIsLoading
  },
  extraReducers: (builder) => {
    builder
      .addCase("editor/selectToolbarDisplay", (state, action) => {
        state.toolbarDisplay = action.payload;
      })
  },
});
export const { actions, reducer } = editorSlice;

export default editorSlice.reducer;
